/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/extensions */
import { loadSelf } from "@fdn/profile_store";
import Env from "Consts/env";
import Layout from "Containers/layout";
import cookie from "cookie";
import {
	checkDevice,
} from "Helpers/utils";
import { END } from "redux-saga";
import { wrapper } from "Store/index";
import { loadHighlightReview } from "Store/HightlightReview/lib/actions";
import vars from "Consts/vars";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadSearchResult } from "Store/SearchResult/lib/actions";
import { loadSearchBrands } from "Store/SearchBrands/lib/actions";
import { loadSearchBrandService } from "store/searchBrandService/lib/actions";
import { loadSearchProducts } from "Store/SearchProducts/lib/actions";
import { loadSearchServices } from "Store/SearchServices/lib/actions";
import { loadSearchArticles } from "Store/SearchArticles/lib/actions";
import { loadSearchUsers } from "Store/SearchUsers/lib/actions";
// import { loadCategory } from "Store/ProductCategory/lib/actions";
// import Cookies from "js-cookie";
import { loadBrandList } from "Store/BrandList/lib/actions";
import { useRouter } from "next/router";
import SearchResult from "../containers/search_result/searchResult";

export const PILLS = {
	PRODUCT: "product",
	SERVICE: "service",
};

const PILLS_DATA = [
	{
		label: "Product",
		value: PILLS.PRODUCT,
	},
	{
		label: "Salon & Clinic",
		value: PILLS.SERVICE,
	},
];

const Index = (props) => {

	const prop = props;
	const dispatch = useDispatch();
	const getData = useSelector((state) => state);
	const router = useRouter();

	const [allResult, setAllResult] = useState([]);
	const [products, setProductsResult] = useState([]);
	const [services, setServicesResult] = useState([]);
	const [brands, setBrandsResult] = useState([]);
	const [brandService, setBrandServiceResult] = useState([]);
	const [users, setUsersResult] = useState([]);
	const [articles, setArticlesResult] = useState([]);

	const [checkSort, setCheckSort] = useState(false);
	const [listSorting, setListSorting] = useState();

	const [activePill, setActivePill] = useState(
		vars.DEFAULT_TYPE_REVIEW_FD_PROFILE.includes(router.query.type)
			? router.query.type
			: PILLS.PRODUCT,
	);

	const handleActivePills = (pillValue) => {

		setActivePill(pillValue);
		router.push(
			{
				pathname: "/search",
				query: {
					q: prop.query.q,
					tab: "brands",
					type: pillValue,
				},
			},
			undefined,
			{ shallow: true },
		);

	};

	// -----------------------handle reload & for first fetching data---------------------------
	const handleReloadBrand = ({
		page = 1, limit = prop.isMobile ? 20 : 48, next_id = "", type = "brand-product", keyword = "",
	}) => {

		dispatch(
			loadSearchBrands({
				payload: {
					headers: Env.HEADERS,
					is_server: true,
					keyword,
					limit,
					page,
					next_id,
					type,
					sort: "highest",
				},
			}),
		);

	};

	const handleReloadBrandService = ({
		page = 1, limit = prop.isMobile ? 20 : 48, next_id = "", type = "brand-service", keyword = "",
	}) => {

		dispatch(
			loadSearchBrandService({
				payload: {
					headers: Env.HEADERS,
					is_server: true,
					keyword,
					limit,
					page,
					next_id,
					type,
					sort: "highest",
				},
			}),
		);

	};

	// handle Reloard product
	const handleReloadProduct = ({
		page = 1, limit = prop.isMobile ? 10 : 24, next_id = "", type = "product", keyword = "", sort = "",
	}) => {

		dispatch(
			loadSearchProducts({
				payload: {
					headers: Env.HEADERS,
					is_server: true,
					keyword,
					limit,
					page,
					next_id,
					type,
					sort,
				},
			}),
		);

	};
	const handleReloadServices = ({
		page = 1, limit = prop.isMobile ? 10 : 24, next_id = "", type = "service", keyword = "", sort = "",
	}) => {

		dispatch(
			loadSearchServices({
				payload: {
					headers: Env.HEADERS,
					is_server: true,
					keyword,
					limit,
					page,
					next_id,
					type,
					sort,
				},
			}),
		);

	};
	const handleReloadArticle = ({
		page = 1, limit = prop.isMobile ? 10 : 12, next_id = "", type = "article", keyword = "",
	}) => {

		dispatch(
			loadSearchArticles({
				payload: {
					headers: Env.HEADERS,
					is_server: true,
					keyword,
					limit,
					page,
					next_id,
					type,
					sort: "highest",
				},
			}),
		);

	};

	const handleReloadUser = ({
		page = 1, limit = prop.isMobile ? 10 : 40, next_id = "", type = "user", keyword = "",
	}) => {

		dispatch(
			loadSearchUsers({
				payload: {
					headers: Env.HEADERS,
					is_server: true,
					keyword,
					limit,
					page,
					next_id,
					type,
					sort: "highest",
				},
			}),
		);

	};

	// ----------------------------------------------------------------

	// * update data per keyword & FIRST FETCHING DATA
	useEffect(() => {

		// first fetch for type all
		dispatch(
			loadSearchResult({
				payload: {
					headers: Env.HEADERS,
					is_server: true,
					keyword: prop.query.q,
					next_id: getData.storeSearchResult?.data?.pagination?.next_id
						&& getData.storeSearchResult?.data?.pagination?.next_id,
					type: "all",
					sort: "highest",
					page: 1,
				},
			}),
		);

		handleReloadBrand({
			keyword: prop.query.q,
			next_id: getData.storeSearchBrands?.data?.pagination?.next_id
				? getData.storeSearchBrands?.data?.pagination?.next_id : 0,
		});

		handleReloadBrandService({
			keyword: prop.query.q,
			next_id: getData.storeSearchBrandService?.data?.pagination?.next_id
				? getData.storeSearchBrandService?.data?.pagination?.next_id : 0,
		});

		handleReloadProduct({
			keyword: prop.query.q,
			next_id: getData.storeSearchProducts?.data?.pagination?.next_id
				? getData.storeSearchProducts?.data?.pagination?.next_id : 0,
			sort: "popular",
		});

		handleReloadServices({
			keyword: prop.query.q,
			next_id: getData.storeSearchServices?.data?.pagination?.next_id
				? getData.storeSearchServices?.data?.pagination?.next_id : 0,
			sort: "popular",
		});

		handleReloadArticle({
			keyword: prop.query.q,
			next_id: getData.storeSearchArticles?.data?.pagination?.next_id
				? getData.storeSearchArticles?.data?.pagination?.next_id : 0,
		});

		handleReloadUser({
			keyword: prop.query.q,
			next_id: getData.storeSearchUsers?.data?.pagination?.next_id
				? getData.storeSearchUsers?.data?.pagination?.next_id : 0,
		});

	}, [prop.query.q]);

	useEffect(() => {

		// dispatch(
		// 	loadCategory({}),
		// );

		dispatch(
			loadBrandList({}),
		);

	}, []);

	// * all result data
	useEffect(() => {

		if (!getData.storeSearchResult?.data?.data) {

			return;

		}
		setAllResult(getData.storeSearchResult?.data?.data);

	}, [getData.storeSearchResult?.data?.data]);

	// * Product Data
	useEffect(() => {

		if (Array.isArray(getData.storeSearchProducts?.data?.data?.products)) {

			if (getData.storeSearchProducts?.data?.data?.products.length > 0) {

				if (checkSort) {

					setProductsResult(getData.storeSearchProducts?.data);

				} else {

					setProductsResult((prev) => {

						if (prev.length === 0) {

							return getData.storeSearchProducts?.data;

						}

						const mergedProducts = [
							...prev.data.products, ...getData.storeSearchProducts?.data.data.products,
						];

						return {
							...getData.storeSearchProducts?.data,
							data: {
								products: mergedProducts,
							},
						};

					});

				}

			} else {

				setProductsResult([]);

			}

		}

	}, [getData.storeSearchProducts?.data?.data?.products]);

	//  * get clinic data for keywords sorting
	useEffect(() => {

		if (Array.isArray(getData.storeSearchServices?.data?.data?.services)) {

			if (getData.storeSearchServices?.data?.data?.services.length > 0) {

				if (checkSort) {

					setServicesResult(getData.storeSearchServices?.data);

				} else {

					setServicesResult((prev) => {

						if (prev.length === 0) {

							return getData.storeSearchServices?.data;

						}

						const mergedServices = [
							...prev.data.services, ...getData.storeSearchServices?.data.data.services,
						];

						return {
							...getData.storeSearchServices?.data,
							data: {
								services: mergedServices,
							},
						};

					});

				}

			} else {

				setServicesResult([]);

			}

		}

	}, [getData.storeSearchServices?.data?.data?.services]);

	// brand product
	useEffect(() => {

		if (Array.isArray(getData.storeSearchBrands?.data?.data?.brands)) {

			if (getData.storeSearchBrands?.data?.data?.brands.length > 0) {

				setBrandsResult((prev) => {

					if (prev.length === 0) {

						return getData.storeSearchBrands?.data;

					}

					const mergedBrands = [
						...prev.data.brands, ...getData.storeSearchBrands?.data.data.brands,
					];

					return {
						...getData.storeSearchBrands?.data,
						data: {
							brands: mergedBrands,
						},
					};

				});

			} else {

				setBrandsResult([]);

			}

		}

	}, [getData.storeSearchBrands?.data?.data?.brands]);

	useEffect(() => {

		if (Array.isArray(getData.storeSearchBrandService?.data?.data?.brands)) {

			if (getData.storeSearchBrandService?.data?.data?.brands.length > 0) {

				setBrandServiceResult((prev) => {

					if (prev.length === 0) {

						return getData.storeSearchBrandService?.data;

					}

					const mergedBrands = [
						...prev.data.brands, ...getData.storeSearchBrandService?.data.data.brands,
					];

					return {
						...getData.storeSearchBrandService?.data,
						data: {
							brands: mergedBrands,
						},
					};

				});

			} else {

				setBrandServiceResult([]);

			}

		}

	}, [getData.storeSearchBrandService?.data?.data?.brands]);

	useEffect(() => {

		if (Array.isArray(getData.storeSearchArticles?.data?.data?.articles)) {

			if (getData.storeSearchArticles?.data?.data?.articles.length > 0) {

				setArticlesResult((prev) => {

					if (prev.length === 0) {

						return getData.storeSearchArticles?.data;

					}

					const mergedArticles = [
						...prev.data.articles, ...getData.storeSearchArticles?.data.data.articles,
					];

					return {
						...getData.storeSearchArticles?.data,
						data: {
							articles: mergedArticles,
						},
					};

				});

			} else {

				setArticlesResult([]);

			}

		}

	}, [getData.storeSearchArticles?.data?.data?.articles]);

	useEffect(() => {

		if (Array.isArray(getData.storeSearchUsers?.data?.data?.users)) {

			if (getData.storeSearchUsers?.data?.data?.users.length > 0) {

				setUsersResult((prev) => {

					if (prev.length === 0) {

						return getData.storeSearchUsers?.data;

					}

					const mergedUsers = [
						...prev.data.users, ...getData.storeSearchUsers?.data.data.users,
					];

					return {
						...getData.storeSearchUsers?.data,
						data: {
							users: mergedUsers,
						},
					};

				});

			} else {

				setUsersResult([]);

			}

		}

	}, [getData.storeSearchUsers?.data?.data?.users]);

	// ---------------------------------------------------------------------------------
	const handleSorting = (e) => {

		handleReloadProduct(
			{
				page: 1,
				next_id: getData.storeSearchProducts?.data?.pagination?.next_id,
				type: "product",
				keyword: prop.query.q,
				sort: e.target.value,
			},
		);

		setCheckSort(true);
		setListSorting(e.target.value);

	};

	// ----------------------- handle load more untuk tab ------------------------------
	const handleLoadMoreBrand = () => {

		const page = getData.storeSearchBrands?.data?.pagination.page + 1;
		handleReloadBrand(
			{
				page,
				next_id: getData.storeSearchBrands?.data?.pagination?.next_id,
				keyword: prop.query.q,
			},
		);

	};
	const handleLoadMoreBrandService = () => {

		const page = getData.storeSearchBrandService?.data?.pagination.page + 1;
		handleReloadBrandService(
			{
				page,
				next_id: getData.storeSearchBrands?.data?.pagination?.next_id,
				keyword: prop.query.q,
			},
		);

	};

	const handleLoadMoreArticle = () => {

		const page = getData.storeSearchArticles?.data?.pagination.page + 1;
		handleReloadArticle(
			{
				page,
				keyword: prop.query.q,
				next_id: getData.storeSearchArticles?.data?.pagination?.next_id,
			},
		);

	};

	const handleLoadMoreProduct = () => {

		const page = getData.storeSearchProducts?.data?.pagination.page + 1;
		handleReloadProduct(
			{
				page,
				next_id: getData.storeSearchProducts?.data?.pagination.next_id,
				keyword: prop.query.q,
				sort: listSorting || "popular",
			},
		);

		setCheckSort(false);

	};

	const handleLoadMoreServices = () => {

		const page = getData.storeSearchServices?.data?.pagination.page + 1;
		handleReloadServices(
			{
				page,
				next_id: getData.storeSearchServices?.data?.pagination.next_id,
				keyword: prop.query.q,
				sort: listSorting || "popular",
			},
		);

		setCheckSort(false);

	};

	const handleLoadMoreUser = () => {

		const page = getData.storeSearchUsers?.data?.pagination?.page + 1;
		handleReloadUser(
			{
				page,
				next_id: getData.storeSearchUsers?.data?.pagination?.next_id,
				keyword: prop.query.q,
			},
		);

	};

	return (
		<Layout
			home
			ismobile={prop.isMobile}
			adsHead={prop.adsHead}
			adsFoot={prop.adsFoot}
			pageType="Front Page"
			id="card-top"
		>
			<SearchResult
				pillsData={PILLS_DATA}
				onClickPill={handleActivePills}
				activePill={activePill}
				isMobile={prop.isMobile}
				allResult={allResult}
				dataBrand={brands}
				dataBrandService={brandService}
				dataProduct={products}
				dataServices={services}
				dataArticle={articles}
				dataUser={users}
				defaultPicture={vars.BROKEN_IMAGE.square}
				defaultPictureProfile={vars.BROKEN_IMAGE.user}
				limitDataBrand={7}
				limitDataProduct={6}
				limitDataService={6}
				limitDataArticle={3}
				limitDataUser={4}
				limitDataSuggest={3}
				keyword={prop.query.q}
				query={prop.query}
				isTabAllLoading={getData.storeSearchResult?.status === "fetch_init" || getData.storeSearchResult?.status === "fetch_loading"}
				isTabBrandLoading={getData.storeSearchBrands?.status === "fetch_init" || getData.storeSearchBrands?.status === "fetch_loading"}
				isTabBrandServiceLoading={getData.storeSearchBrandService?.status === "fetch_init" || getData.storeSearchBrandService?.status === "fetch_loading"}
				isTabProductLoading={getData.storeSearchProducts?.status === "fetch_init" || getData.storeSearchProducts?.status === "fetch_loading"}
				isTabServiceLoading={getData.storeSearchServices?.status === "fetch_init" || getData.storeSearchServices?.status === "fetch_loading"}
				isTabUserLoading={getData.storeSearchUsers?.status === "fetch_init" || getData.storeSearchUsers?.status === "fetch_loading"}
				isTabArticleLoading={getData.storeSearchArticles?.status === "fetch_init" || getData.storeSearchArticles?.status === "fetch_loading"}
				// handleReloadData={handleReloadData}
				setCheckSort={setCheckSort}
				handleLoadMoreArticle={handleLoadMoreArticle}
				handleLoadMoreBrand={handleLoadMoreBrand}
				handleLoadMoreBrandService={handleLoadMoreBrandService}
				handleLoadMoreProduct={handleLoadMoreProduct}
				handleLoadMoreServices={handleLoadMoreServices}
				handleSorting={handleSorting}
				handleLoadMoreUser={handleLoadMoreUser}
			/>

		</Layout>
	);

};

export const getServerSideProps = wrapper.getServerSideProps(
	async ({ store, req, query }) => {

		let userAgent;
		let cookies;
		let authorization = null;

		if (req) {

			// if you are on the server and you get a "req" property from your context
			userAgent = req.headers["user-agent"]; // get the user-agent from the headers

		} else {

			// if you are on the client you can access the navigator from the window object
			userAgent = navigator.userAgent;

		}

		// eslint-disable-next-line no-nested-ternary
		const isMobile = userAgent && checkDevice(userAgent);

		const isServer = !!req;

		if (req.headers.cookie) {

			cookies = cookie.parse(req.headers.cookie);
			authorization = cookies.token;

		}

		await store.dispatch(
			loadSelf({
				payload: {
					api_env: process.env.NEXT_PUBLIC_NODE_ENV,
					env: Env.HEADERS,
					Authorization: authorization,
					is_server: isServer,
					is_allo: process.env.NEXT_PUBLIC_ALLO_STATUS === "ON",
				},
			}),
		);

		await store.dispatch(
			loadHighlightReview({
				// Authorization: authorization,
			}),
		);

		store.dispatch(END);
		await store.sagaTask.toPromise();

		const getStoreSelf = !!store.getState().storeSelf.data === true
			? store.getState().storeSelf
			: [];

		const getHighlightReview = store.getState().storeHighlightReview?.data || [];

		return {
			props: {
				query,
				isMobile,
				getStoreSelf,
				getHighlightReview,
			}, // will be passed to the page component as props
		};

	},
);

export default Index;
